import { ThunkAction } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { rootReducer } from "./rootReducer";
import { store } from "./store";

export type RootState = ReturnType<typeof rootReducer>;

export type Thunk<R> = ThunkAction<R, RootState, void, AnyAction>;

// useDispatch<AppDispatch>() returns what a thunk returns (e.g. a Promise).
export type AppDispatch = typeof store.dispatch;

export { store };
